// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bgl_a bik_wj bik_ss bik_xl"};